// lang.js
export const SET_LOCALE = "SET_LOCALE";

// panel.js
export const TOGGLE_SIDEBAR_DESKTOP = "TOGGLE_SIDEBAR_DESKTOP";
export const TOGGLE_SIDEBAR_MOBILE = "TOGGLE_SIDEBAR_MOBILE";
export const TOGGLE = "TOGGLE";
export const MINIMIZE_SIDEBAR = "MINIMIZE_SIDEBAR";
export const SET = "SET";

// auth.js
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_FAILURE = "FETCH_USER_FAILURE";
export const SAVE_TOKEN = "SAVE_TOKEN";
export const SAVE_ACCESS_TOKEN = "SAVE_ACCESS_TOKEN";
export const SAVE_ACCOUNT_EMAIL = "SAVE_ACCOUNT_EMAIL";
export const SAVE_ACCOUNT_TENANT_ID = "SAVE_ACCOUNT_TENANT_ID";
export const LOGOUT = "LOGOUT";
export const SAVE_AUTH_TRIED = "SAVE_AUTH_TRIED";


// filter.js
export const SAVE_RANGE_DATE = "SAVE_RANGE_DATE";
export const DATABASE = "DATABASE";
export const FILTER_TYPE = "FILTER_TYPE";
export const LEAD_TYPE = "LEAD_TYPE";
export const FILTER_ADVANCE = "FILTER_ADVANCE";


// form.js
export const STEPS = "STEPS";
export const STEP_CONTENT = "STEP_CONTENT";

// global.js

export const LOAD_TABLE_DATA = "LOAD_TABLE_DATA";
export const LOAD_CHART_DATA = "LOAD_CHART_DATA";
export const LOAD_DATA = "LOAD_DATA";

export const FORM_DATA = "FORM_DATA";
export const SEND_FORM = "SEND_FORM";
export const FIELDS = "FIELDS";
export const FIELDS_ADVANCE = "FIELDS_ADVANCE";
export const FIELDS_ADVANCE_INDEX_BY_ID = "FIELDS_ADVANCE_INDEX_BY_ID";
export const SUB_TAGS = "SUB_TAGS";
export const BALANCING_SHIPMENT_TYPES = "BALANCING_SHIPMENT_TYPES";
export const REQUEST_CANCEL_TOKEN = "REQUEST_CANCEL_TOKEN";
export const PAGE_NAME = "PAGE_NAME"


// toast.js
export const ADD_FIXED_TOASTS = "ADD_FIXED_TOASTS";
export const RESET_FIXED_TOASTS = "RESET_FIXED_TOASTS";


export const TABLES = "TABLES";
export const UPDATE_TABLE = "UPDATE_TABLE";
export const ADD_TABLE = "ADD_TABLE";
export const APP_ID = "APP_ID";
export const PLUGINS = "INTEGRATION_PLUGINS";
export const PLUGIN_INTEGRATIONS = "PLUGIN_INTEGRATIONS";

export const TRIGGER_EVENTS = "TRIGGER_EVENTS";
export const TRIGGER_PLUGINS = "TRIGGER_PLUGINS";
export const LOADING = "LOADING";
export const LANGUAGES = "LANGUAGES";
export const COUNTRIES = "COUNTRIES";
export const ADD_FILTER = "ADD_FILTER";
export const CLEAR_FILTERES = "CLEAR_FILTERES";







